import { flow } from 'mobx-state-tree';

import http from '@clientCommon/app/bootstrap/http';

import { API_BASE } from '@clientCommon/app/constants';
import { MODEL_ROUTE } from '../../constants';

type Filter = {
  firstName?: string;
  lastName?: string;
  externalPharmacyId?: string;
};

type Query = {
  filter?: Filter;
};

export default flow(function* (filter: Filter = {}) {
  const query: Query = {
    filter,
  };

  const response: number = yield http.get({
    url: `${API_BASE}${MODEL_ROUTE}/count`,
    query,
  });

  return response;
});
